import { Card } from "react-bootstrap";
import styles from './card.module.css'

export const CustomCard = ({children, className, ...props}) => (
    <Card className={`${styles.card} ${className}`} {...props}>{children}</Card>
)